export default __webpack_public_path__ + "assets/models/5660a80bf2dedbe408eb6382a2768a0a.glb";